import { URL_API } from "../init/url";

// golang
// export const APP_ID_AGORA = "3f62b42cfd574fa38768ec2b3a8e281c";
// export const URL_GET_TOKEN =
//   "https://rtm-token-fetch.psikku.com/fetch_rtc_token";

// java
export const APP_ID_AGORA = "9af3e01fb5e044528f6577ba5072edee";
export const URL_GET_TOKEN =
  URL_API + "/api/project/assessmentMethodSession/agoraToken";

export const APP_ID_AGORA_PDULI = "3f62b42cfd574fa38768ec2b3a8e281c";
export const URL_GET_TOKEN_PDULI =
  "https://rtm-token-fetch.psikku.com/fetch_rtc_token";
